import OrderTrackPageFeature from "./OrderTrackPageFeature";

export default OrderTrackPageFeature;
